import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';

import './feedback-screen.scss';

export function FeedbackScreen({ isMatchingVIN = false, activeStep = '', isPreVinFlow = false }) {
  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
      event_data: {
        action_name: TrackingConstant.ACTION_WIDGET_VIEW,
        action_cause: 'scroll',
        creative_id: updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: `${activeStep}_spinner` }),
      },
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <div className="text-center my-3_5" data-tracking-parent="review_spinner">
      <div className="spinner-container pos-r">
        <Spinner size={122} thickness={8} color="primary" className="align-middle" />
        <img className="offer-img" src={getStaticImageUrl('/img/car-buying/capital1/offer.svg')} alt="" />
      </div>
      <div className="heading-4 mt-1 mb-0_5">
        One moment...
        <br />
        We are working on getting your
        <br />
        pre-qualified terms
      </div>
      <div>Please stay on this page.</div>
    </div>
  );
}
FeedbackScreen.propTypes = {
  isMatchingVIN: PropTypes.bool,
  activeStep: PropTypes.string,
  isPreVinFlow: PropTypes.bool,
};
